// source: cross_reference.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_api_annotations_pb = require('./google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest;
  return proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse;
  return proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildCrossReferenceGraphResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest;
  return proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, ""),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
sheetId: jspb.Message.getFieldWithDefault(msg, 3, ""),
title: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode;
  return proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSheetId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSheetId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string file_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string sheet_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.prototype.getSheetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.prototype.setSheetId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.toObject = function(includeInstance, msg) {
  var f, obj = {
source: (f = msg.getSource()) && proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.toObject(includeInstance, f),
target: (f = msg.getTarget()) && proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.toObject(includeInstance, f),
type: jspb.Message.getFieldWithDefault(msg, 3, ""),
weight: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
reference: jspb.Message.getFieldWithDefault(msg, 5, ""),
detectedBy: jspb.Message.getFieldWithDefault(msg, 6, ""),
sourceLabel: jspb.Message.getFieldWithDefault(msg, 7, ""),
targetLabel: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge;
  return proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.deserializeBinaryFromReader);
      msg.setSource(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.deserializeBinaryFromReader);
      msg.setTarget(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWeight(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setReference(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetectedBy(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceLabel(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.serializeBinaryToWriter
    );
  }
  f = message.getTarget();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getReference();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDetectedBy();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSourceLabel();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTargetLabel();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional CrossReferenceNode source = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.getSource = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} returns this
*/
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.setSource = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.clearSource = function() {
  return this.setSource(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.hasSource = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CrossReferenceNode target = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.getTarget = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} returns this
*/
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.setTarget = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.clearTarget = function() {
  return this.setTarget(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.hasTarget = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double weight = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.getWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.setWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional string reference = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.getReference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.setReference = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string detected_by = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.getDetectedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.setDetectedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string source_label = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.getSourceLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.setSourceLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string target_label = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.getTargetLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.prototype.setTargetLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
version: jspb.Message.getFieldWithDefault(msg, 1, 0),
builtAt: jspb.Message.getFieldWithDefault(msg, 2, ""),
nodesList: jspb.Message.toObjectList(msg.getNodesList(),
    proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.toObject, includeInstance),
edgesList: jspb.Message.toObjectList(msg.getEdgesList(),
    proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.toObject, includeInstance),
exists: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse;
  return proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuiltAt(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.deserializeBinaryFromReader);
      msg.addNodes(value);
      break;
    case 4:
      var value = new proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.deserializeBinaryFromReader);
      msg.addEdges(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBuiltAt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNodesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode.serializeBinaryToWriter
    );
  }
  f = message.getEdgesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional int32 version = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string built_at = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.getBuiltAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.setBuiltAt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated CrossReferenceNode nodes = 3;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode>}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.getNodesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode, 3));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.setNodesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.addNodes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.clearNodesList = function() {
  return this.setNodesList([]);
};


/**
 * repeated CrossReferenceEdge edges = 4;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge>}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.getEdgesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge, 4));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.setEdgesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.addEdges = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.clearEdgesList = function() {
  return this.setEdgesList([]);
};


/**
 * optional bool exists = 5;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossReferenceGraphResponse.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, ""),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
projectionType: jspb.Message.getFieldWithDefault(msg, 3, ""),
description: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance;
  return proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectionType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getProjectionType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string file_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string projection_type = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.prototype.getProjectionType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.prototype.setProjectionType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.toObject = function(includeInstance, msg) {
  var f, obj = {
elementId: jspb.Message.getFieldWithDefault(msg, 1, ""),
canonicalName: jspb.Message.getFieldWithDefault(msg, 2, ""),
elementType: jspb.Message.getFieldWithDefault(msg, 3, ""),
appearancesList: jspb.Message.toObjectList(msg.getAppearancesList(),
    proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.toObject, includeInstance),
identityClass: jspb.Message.getFieldWithDefault(msg, 5, ""),
confidence: jspb.Message.getFieldWithDefault(msg, 6, ""),
matchingBasis: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement;
  return proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setElementId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCanonicalName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setElementType(value);
      break;
    case 4:
      var value = new proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.deserializeBinaryFromReader);
      msg.addAppearances(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentityClass(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfidence(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchingBasis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getElementId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCanonicalName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getElementType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAppearancesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance.serializeBinaryToWriter
    );
  }
  f = message.getIdentityClass();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getConfidence();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMatchingBasis();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string element_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.getElementId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.setElementId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string canonical_name = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.getCanonicalName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.setCanonicalName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string element_type = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.getElementType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.setElementType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ElementAppearance appearances = 4;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance>}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.getAppearancesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance, 4));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement} returns this
*/
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.setAppearancesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.addAppearances = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.org.codetricks.construction.code.assistant.service.crossref.ElementAppearance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.clearAppearancesList = function() {
  return this.setAppearancesList([]);
};


/**
 * optional string identity_class = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.getIdentityClass = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.setIdentityClass = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string confidence = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.getConfidence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string matching_basis = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.getMatchingBasis = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.prototype.setMatchingBasis = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest;
  return proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse;
  return proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.BuildElementRegistryResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest;
  return proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
version: jspb.Message.getFieldWithDefault(msg, 1, 0),
builtAt: jspb.Message.getFieldWithDefault(msg, 2, ""),
elementsList: jspb.Message.toObjectList(msg.getElementsList(),
    proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.toObject, includeInstance),
exists: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse;
  return proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuiltAt(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.deserializeBinaryFromReader);
      msg.addElements(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBuiltAt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getElementsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional int32 version = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string built_at = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.prototype.getBuiltAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.prototype.setBuiltAt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated BuildingElement elements = 3;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement>}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.prototype.getElementsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement, 3));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.prototype.setElementsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.prototype.addElements = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.org.codetricks.construction.code.assistant.service.crossref.BuildingElement, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.prototype.clearElementsList = function() {
  return this.setElementsList([]);
};


/**
 * optional bool exists = 4;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetElementRegistryResponse.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.toObject = function(includeInstance, msg) {
  var f, obj = {
edge: (f = msg.getEdge()) && proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.toObject(includeInstance, f),
findingType: jspb.Message.getFieldWithDefault(msg, 2, ""),
severity: jspb.Message.getFieldWithDefault(msg, 3, ""),
confidence: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
detail: jspb.Message.getFieldWithDefault(msg, 5, ""),
sourceExcerpt: jspb.Message.getFieldWithDefault(msg, 6, ""),
targetExcerpt: jspb.Message.getFieldWithDefault(msg, 7, ""),
recommendation: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding;
  return proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.deserializeBinaryFromReader);
      msg.setEdge(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFindingType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeverity(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setConfidence(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceExcerpt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetExcerpt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecommendation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEdge();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge.serializeBinaryToWriter
    );
  }
  f = message.getFindingType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSeverity();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getConfidence();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getDetail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSourceExcerpt();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTargetExcerpt();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRecommendation();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional CrossReferenceEdge edge = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.getEdge = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.service.crossref.CrossReferenceEdge|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding} returns this
*/
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.setEdge = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.clearEdge = function() {
  return this.setEdge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.hasEdge = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string finding_type = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.getFindingType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.setFindingType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string severity = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.getSeverity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.setSeverity = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double confidence = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.getConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional string detail = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.getDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.setDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string source_excerpt = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.getSourceExcerpt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.setSourceExcerpt = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string target_excerpt = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.getTargetExcerpt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.setTargetExcerpt = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string recommendation = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.getRecommendation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.prototype.setRecommendation = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest;
  return proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse;
  return proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.RunCrossExaminationResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest;
  return proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
builtAt: jspb.Message.getFieldWithDefault(msg, 1, ""),
findingsList: jspb.Message.toObjectList(msg.getFindingsList(),
    proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.toObject, includeInstance),
exists: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
matches: jspb.Message.getFieldWithDefault(msg, 4, 0),
discrepancies: jspb.Message.getFieldWithDefault(msg, 5, 0),
contradictions: jspb.Message.getFieldWithDefault(msg, 6, 0),
missingTargets: jspb.Message.getFieldWithDefault(msg, 7, 0),
edgesExamined: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse;
  return proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuiltAt(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.deserializeBinaryFromReader);
      msg.addFindings(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMatches(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiscrepancies(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContradictions(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMissingTargets(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEdgesExamined(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBuiltAt();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFindingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getMatches();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getDiscrepancies();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getContradictions();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMissingTargets();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getEdgesExamined();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional string built_at = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.getBuiltAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.setBuiltAt = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated CrossExaminationFinding findings = 2;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding>}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.getFindingsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding, 2));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.setFindingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.addFindings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.org.codetricks.construction.code.assistant.service.crossref.CrossExaminationFinding, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.clearFindingsList = function() {
  return this.setFindingsList([]);
};


/**
 * optional bool exists = 3;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional int32 matches = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.getMatches = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.setMatches = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 discrepancies = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.getDiscrepancies = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.setDiscrepancies = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 contradictions = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.getContradictions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.setContradictions = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 missing_targets = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.getMissingTargets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.setMissingTargets = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 edges_examined = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.getEdgesExamined = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.crossref.GetCrossExaminationResponse.prototype.setEdgesExamined = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.service.crossref);
